<template>
  <div class="news-admin-page">
    <AppBackButton link="/admin/news" :linkMode="true">
      <AppIcon icon="back-arrow-icon" />
      <span>{{ t("to.news") }}</span>
    </AppBackButton>
    <AdminPageTitle :title="'Ярлыки статей'" class="mt-10"/>
    <AppButton
      @click="addTag"
      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
    >
      <span>Добавить</span>
    </AppButton>

    <v-dialog
      v-model="showNewsTagForm"
      transition="dialog-bottom-transition"
      persistence
      style="width: 380px;"
    >
      <v-card>
        <v-card-title class="card_ligth_header">
          <h5 v-if="!!this.id">Редактирование тега</h5>
          <h5 v-else>Добавление тега</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="newsForm">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field style="width: 350px;"
                    label="Название*"
                    v-model="tagName"
                    :counter="250"
                    variant="outlined"
                    hint="Укажите название тега"
                    required
                  ></v-text-field>
                  <div
                    class="input-errors"
                    v-for="error of v$.tagName.$errors"
                    :key="error.$uid"
                  >
                    <div class="error-msg form__tip form__tip--error showing">
                      {{ error.$message }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-label>Статус тега*</v-label>
                  <v-row class="px-4" fluid>
                    <v-switch
                      v-model="active"
                      color="success"
                    ></v-switch>
                    <v-chip class="ma-2" v-if="active"> Активно</v-chip><v-chip v-else class="ma-2"> Не активно</v-chip>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            <small>*обязательно для заполнения</small>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card_ligth_actions">
          <v-spacer></v-spacer>
          <AppButton
            class="admin-lib__opener d-flex flex__ai-c"
            @click="closeNewsTag"
          >
            <span>Отмена</span>
          </AppButton>
          <AppButton
            class="admin-lib__opener d-flex flex__ai-c"
            @click="saveNewsTag"
            :disabled="saveIsDisable"
          >
            <span>Сохранить</span>
          </AppButton>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <StateWrapper
      :content="newsTags"
      :loadingStatus="loadingStatus"
      :checkLogin="true"
    >
      <div class="wrapper">
        <div class="news-admin-page__results">
          <div class="news-admin-page__items" v-if="newsTags">
            <AccordionItemWithEdit
              v-for="(v, idx) in newsTags"
              :key="v.id"
              :isOpen="currentId === v.id"
              @open="setCurrentId"
              :style="{ 'animation-delay': `0.${idx}s` }"
              :id="v.id"
            >
              <template v-slot:top>
                <span v-if="v.tagName">{{ v.tagName }}</span>
              </template>
              <template v-slot:bottom>
                <div class="ma-2">
                  <h3>Активен:</h3>
                  <p v-if="v.active">Да</p>
                  <p v-else>Нет</p>
                </div>
                <v-divider color="accent" class="mt-8"></v-divider>
                <div class="ma-2">
                  <v-row>
                    <v-spacer></v-spacer>
                    <AppButton
                      @click="deleteNewsTag(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Удалить</span>
                    </AppButton>
                    <AppButton
                      @click="editNewsTag(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Редактировать</span>
                    </AppButton>
                  </v-row>
                </div>
              </template>
            </AccordionItemWithEdit>
          </div>
        </div>
      </div>
    </StateWrapper>
  </div>
</template>

<script>
import AppIcon from "@/elements/AppIcon.vue";
import { useRouter } from "vue-router";
import AppBackButton from "@/elements/AppBackButton.vue";
import { onMounted, ref, computed } from "vue";
import { t } from "@/utils/translate";
import { customAxios } from "@/service/customAxios";
import AccordionItemWithEdit from "@/components/AccordionItemWithEdit.vue";
import AdminPageTitle from "@/elements/AdminPageTitle.vue";
import StateWrapper from "@/components/StateWrapper.vue";
import { setCurrentIdValue } from "@/utils/common";
import AppButton from "@/elements/AppButton.vue";
import { required, maxLength, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { usePopupStore } from "@/store/popupStore";

export default {
  components: {
    StateWrapper,
    AdminPageTitle,
    AccordionItemWithEdit,
    AppButton,
    AppBackButton,
    AppIcon
  },
  setup() {
    const router = useRouter();
    const id = ref();
    const tagName = ref("");
    const active = ref(true);
    const newsTags = ref([]);
    const showNewsTagForm = ref(false);

    const errorBody = ref("");
    const { showPopup } = usePopupStore();

    const rules = {
      tagName: {
        required: helpers.withMessage("Обязательное поле", required),
        max: helpers.withMessage("Не более 250 символов", maxLength(250)),
      }
    };

    const v$ = useVuelidate(rules, {
      tagName: tagName,
    });

    const loadingStatus = ref("loading");
    const currentId = ref(null);

    function setCurrentId(value) {
      currentId.value = setCurrentIdValue(value, currentId.value);
    }

    const saveIsDisable = computed(() => {
      return checkInvalidation();
    });

    function checkInvalidation() {
      v$.value.$touch();
      return v$.value.$invalid;
    }

    function formatDate(dateString) {
      let formatter = new Intl.DateTimeFormat("ru", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
    }

    async function getNewsTags(){
      const resp = await getNewsTagsHandler();
      if (resp.status === 200) {
        newsTags.value = resp.data;
      }
    }

    async function getNewsTagsHandler() {
        loadingStatus.value = "loading";
      try {
        const r = await customAxios.get("news/tag");
        loadingStatus.value = "loaded";
        return r;
      } catch (e) {
        loadingStatus.value = "error";
        console.log(e);
      }
    }

    function capitalizeFirstLetter(string) {
      if(string && string.length > 0){
        return string.charAt(0).toUpperCase() + string.slice(1);
      } else {
        return ''
      }
    }

    function addTag() {
      showNewsTagForm.value = true;
    }

    function editNewsTag(item){
      id.value = item.id;
      tagName.value = item.tagName;
      active.value = item.active;
      showNewsTagForm.value = true;
    }

    function closeNewsTag(){
      id.value = "";
      tagName.value = "";
      active.value = false;
      showNewsTagForm.value = false;
    }

    async function saveNewsTag() {
      errorBody.value = '';
      let newsTag = {
        tagName: capitalizeFirstLetter(tagName.value),
        active: active.value,
      }
      if (id.value) {
        try{
          const r = await customAxios.put('news/tag/' + id.value, newsTag)
          if (r.status === 202) {
            showPopup("Ярлык успешно обновлен!", "success");
            closeNewsTag();
            await getNewsTags();
          }
        } catch (e) {
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
        }
      } else {
        try{
          const r = await customAxios.post('news/tag', newsTag);
          if (r.status === 201) {
            showPopup("Ярлык успешно добавлен!", "success");
            closeNewsTag();
            await getNewsTags();
          }
        } catch(e){
          if(e.response && e.response.data && e.response.data.message){
            errorBody.value = e.response.data.message;
          } else {
            errorBody.value = t("something.went.wrong");
          }
          showPopup(errorBody.value, "error");
        }
      }
    }

    async function deleteNewsTag(news){
      try {
        const r = await customAxios.delete('news/tag/' + news.id)
        console.log("r: " + r);
        if(r.status === 202){
          showPopup(r.data.message, "success");
          closeNewsTag();
          await getNewsTags();
        }
      } catch (e) {
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        } else {
          showPopup(t("something.went.wrong"), "error");
        }
      }
    }

    onMounted(async () => {
      await getNewsTags();
    });

    return {
      loadingStatus,
      t,
      setCurrentId,
      currentId,
      capitalizeFirstLetter,
      rules,
      v$,
      errorBody,
      formatDate,
      id,
      tagName,
      active,
      newsTags,
      showNewsTagForm,
      deleteNewsTag,
      saveNewsTag,
      closeNewsTag,
      editNewsTag,
      saveIsDisable,
      router,
      addTag
    };
  },
};
</script>

<style lang="scss">
.news-admin-page {
    &__chips {
        margin-top: 5px;
        display: flex;
        flex-wrap: wrap;

        span {
            color: $accent-1;
            border: 1px dashed $accent-1;
            padding: 8px;
            margin: 8px;
            border-radius: 10px;
        }
    }

    &__filters {
        text-align: left;
        margin-bottom: 60px;
    }

    &__filters-title {
        margin-bottom: 10px;
    }

    &__theme {
        @include button-default-not-accent;
        display: none;
        margin-right: 8px;

        &.active {
            display: flex;
        }

        &.current {
            background-color: $accent-1;
            color: #fff;
        }
    }

    &__search {
        margin-bottom: 60px;
    }

    .wrapper {
        @include page;
    }

    ul {
        margin-left: 40px;
    }

    &__items {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 40px;
        width: 100%;
        margin: 0 auto;
        margin-top: 30px;
    }

    &__btn {
        @include button-default-not-accent;

        &.active {
            @include button-default;
        }

        & + .news-admin-page__btn {
            margin-left: 16px;
        }
    }
}
</style>
